import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/new/home_time.png'
import _imports_1 from '@/assets/img/new/home_liveing.gif'
import _imports_2 from '@/assets/img/new/null_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-53e87933"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home_box" }
const _hoisted_2 = { class: "top_box" }
const _hoisted_3 = { class: "seach_box" }
const _hoisted_4 = { class: "main_box" }
const _hoisted_5 = {
  key: 0,
  class: "curriculumDiv"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "video_img" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  class: "video_update"
}
const _hoisted_11 = {
  key: 3,
  class: "video_update"
}
const _hoisted_12 = {
  key: 0,
  class: "video_status"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_14 = {
  key: 1,
  class: "video_status"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_16 = {
  key: 2,
  class: "video_status"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_18 = { class: "video_title" }
const _hoisted_19 = { class: "tit_name" }
const _hoisted_20 = { class: "video_name" }
const _hoisted_21 = { class: "video_span" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 1,
  class: "null_box"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无数据", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 2,
  class: "pagin_box pagin_box1"
}
const _hoisted_28 = { class: "pagin_tiao" }

import { onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import dataInit from './hooks/live_menu' // 混入菜单栏
import { useStore } from 'vuex';
import Screen from "@/components/Screen/index.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { isShow, GetLiveList, GetLiveMenu } = dataInit()
let person: any = reactive({
    menuList: [], // 年级列表
    searchId: [],
    parme: [],
    parId: 0,// 父级id
    AliasName: '', // 父级类型名
    listType:0,
    PageType:0,
    IsHome:0,
    data: {
        list: [],
        PageIndex: 1,
        PageSize: 12,
        total: 0
    },
    obj:{},
    cache: '',
    RecordId: 0,
    RecordPageIndex: 0, // 获取通过分页，缓存的页码
    typePageName:0, // 获取通过分页，缓存的哪个页面
    typeName: 0, // 获取通过筛选确认，缓存的哪个页面
    imgs: [require('@/assets/img/new/course_1.png'), require('@/assets/img/new/course_2.png'), require('@/assets/img/new/course_3.png')]
})

const router = useRouter();
const store = useStore()

onMounted(() => {
    // 判断是主页，头部不加背景色
    if (router.currentRoute.value.name !== 'teaIndex') {
        store.commit('setIsBg', true)
    }
    // 获取缓存的id
    person.obj = JSON.parse(JSON.parse(JSON.stringify(window.localStorage.getItem("listType1"))))
    if (person.obj) {
        person.parId = person.obj.Id
        person.AliasName = person.obj.AliasName
        person.listType = person.obj.listType
        person.PageType = person.obj.PageType
        person.IsHome = person.obj.IsHome
        // 判断从那个页面跳转过来的
        if (person.PageType === 3 || person.PageType === 4) {
            // 获取当前选中的最后一个Id
            let anArray = JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem("clickRecord1"))))
            if (anArray && anArray.length > 0) {
                person.RecordId = anArray[anArray.length - 1].key
                // 获取筛选确认后，存的哪个页面
                person.typeName = anArray[anArray.length - 1].typeName
            }
            // 获取通过分页，缓存的当前页码和当前页面
            let RecordPage = JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem("RecordPageIndex1"))))
            if (RecordPage) {
                person.RecordPageIndex = RecordPage.PageIndex
                person.typePageName = RecordPage.typeName
            }
            load()
        }
    }
})
// 获取左菜单数据
const load = async () => {
    person.parId = 0
    const data = await GetLiveMenu(person.parId, 0, person.listType)
    if (data.length > 0) {
        person.menuList = data
        // 判断当前页有没有选中id，有则取出id并请求列表数据，否则初始化id为0
        if (person.typeName === person.PageType && person.IsHome === 0){
            person.parId = person.RecordId
        }else{
            person.parId = 0
            person.data.PageIndex = 1
        }
        // 判断当前页有没有选中分页下标为几，有则取出来某一页，否则初始化分页下标 PageIndex为1
        if (person.typePageName === person.PageType) {
            person.data.PageIndex = person.RecordPageIndex
        } else {
            person.data.PageIndex = 1
        }

        GetLiveList(person.data, person.parId, person.listType)
    }else{
        person.menuList = []
    }
}
// 返回上一页
const backClick=()=>{
    router.push('/teaIndex')
}

// 年级切换
const gradeMenu = (item: any) => {
    person.parId = item
    if (!person.RecordId) {
        GetLiveList(person.data, person.parId, person.listType)
        person.data.PageIndex = 1
    }
}
// 确认筛选
const okMenu = (lastId: number) => {
    person.parId=lastId
    person.data.PageIndex = 1
    // 筛选切换初始化页码
    if (person.PageType === 3) {
        let obj = { PageIndex: person.data.PageIndex, typeName: 3 }
        localStorage.setItem('RecordPageIndex1', JSON.stringify(obj))
    } else if (person.PageType === 4) {
        let obj = { PageIndex: person.data.PageIndex, typeName: 4 }
        localStorage.setItem('RecordPageIndex1', JSON.stringify(obj))
    }
    GetLiveList(person.data, lastId, person.listType)
    // 筛选切换初始化id
    if (person.PageType === 3) {
        let obj = { Id: person.parId, AliasName: person.AliasName, listType: 1, PageType: 3, IsHome: 0 }
        localStorage.setItem('listType1', JSON.stringify(obj))
    } else if (person.PageType === 4) {
        let obj = { Id: person.parId, AliasName: person.AliasName, listType: 2, PageType: 4, IsHome: 0 }
        localStorage.setItem('listType1', JSON.stringify(obj))
    }
}

let toStudy = (item: any) => {
    let obj = { NodeId: item.Id, Id: item.Id, IsCollect: -1 }
    localStorage.setItem('setId', JSON.stringify(obj))
    router.push({ name: 'liveDetails' })
}
// 分页
const currentChange = (val: number) => {
    person.data.PageIndex = val
    let anArray = JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem("clickRecord1"))))
    if (anArray && anArray.length > 0) {
        person.parId = anArray[anArray.length - 1].key
    }
    GetLiveList(person.data, person.parId, person.listType)
    if (person.PageType === 3) {
        let obj = { PageIndex: val, typeName: 3 }
        localStorage.setItem('RecordPageIndex1', JSON.stringify(obj))
    } else if (person.PageType === 4) {
        let obj = { PageIndex: val, typeName: 4 }
        localStorage.setItem('RecordPageIndex1', JSON.stringify(obj))
    }
}

return (_ctx: any,_cache: any) => {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "seach_back",
          onClick: backClick
        }, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_ArrowLeft)
            ]),
            _: 1
          }),
          _createTextVNode(_toDisplayString(_unref(person).AliasName ?
                        _unref(person).AliasName : '暂无类别'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_unref(person).menuList && _unref(person).menuList.length > 0)
          ? (_openBlock(), _createBlock(Screen, {
              key: 0,
              class: "left_screen",
              onGradeMenu: gradeMenu,
              onOkMenu: okMenu,
              leftData: _unref(person).menuList,
              PageType: _unref(person).PageType,
              IsHome: _unref(person).IsHome
            }, null, 8, ["leftData", "PageType", "IsHome"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "main_scroll",
          style: _normalizeStyle(_unref(person).menuList && _unref(person).menuList.length > 0 ? 'width:77.5% !important;' : 'width:100% !important;')
        }, [
          (!_unref(isShow) && _unref(person).data.list && _unref(person).data.list.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(person).data.list, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "main_item",
                    key: index,
                    onClick: ($event: any) => (_unref(toStudy)(item))
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      (item.CoverUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: item.CoverUrl,
                            alt: ""
                          }, null, 8, _hoisted_8))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _unref(person).imgs[Math.floor(Math.random() * (_unref(person).imgs.length))],
                            alt: ""
                          }, null, 8, _hoisted_9)),
                      (!item.PlayStatus)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, "更新日期: " + _toDisplayString(item.UpdateTime), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            (item.PlayStatus === 1 && item.IsDayPlay===1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _hoisted_13,
                                  _createTextVNode("今日直播 " + _toDisplayString(item.BeginTime), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (item.PlayStatus === 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _hoisted_15,
                                  _createTextVNode("直播中 ")
                                ]))
                              : _createCommentVNode("", true),
                            (item.IsDayPlay === 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _hoisted_17,
                                  _createTextVNode("下一场直播 " + _toDisplayString(item.BeginTime), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("p", _hoisted_19, _toDisplayString(item.Name), 1),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, " 课时:" + _toDisplayString(item.ClassHour) + "节 ", 1),
                        (item.TeacherName)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, "主讲：" + _toDisplayString(item.TeacherName), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 8, _hoisted_6))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26)),
          (_unref(person).data.total > _unref(person).data.PageSize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createVNode(_component_el_pagination, {
                  layout: "prev, pager, next, jumper",
                  "current-page": _unref(person).data.PageIndex,
                  "page-size": _unref(person).data.PageSize,
                  total: _unref(person).data.total,
                  onCurrentChange: currentChange
                }, null, 8, ["current-page", "page-size", "total"]),
                _createElementVNode("div", _hoisted_28, "每页 " + _toDisplayString(_unref(person).data.PageSize) + " 条，共 " + _toDisplayString(_unref(person).data.total) + " 条", 1)
              ]))
            : _createCommentVNode("", true)
        ], 4)
      ])
    ])
  ]))
}
}

})